export default {
    data() {
    	return {
        	texts: crb_booking_app.texts
    	}
    }
}


// WEBPACK FOOTER //
// ./src/mixins/texts.js